/**
 * The O Collection — persistent site atmosphere (real footage).
 * A fixed, full-viewport looping video sits behind every section below
 * the hero: real golden-hour Mediterranean water. Any full-bleed banner
 * (hero, collection banner) has its own opaque background that occludes
 * the video visually while it's on screen, so the fade-in is deliberately
 * fast and starts almost immediately on scroll — by design it's often
 * already ramped up *underneath* that opaque banner, ready to show the
 * moment the visitor scrolls past it, rather than requiring several more
 * scrolls before it becomes visible.
 */
(function () {
  "use strict";

  var video = document.querySelector("[data-atmosphere-video]");
  if (!video) return;

  var prefersReducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  ).matches;

  if (prefersReducedMotion) {
    video.pause();
    video.style.opacity = "0.55";
    return;
  }

  var playPromise = video.play();
  if (playPromise && typeof playPromise.catch === "function") {
    playPromise.catch(function () {
      // Autoplay blocked (rare with muted+playsinline) — leave paused,
      // the poster/first frame still reads fine behind the sections.
    });
  }

  var heroEl = document.querySelector("[data-header-transparent-zone]");
  // The product page has no full-bleed banner, but all of its reading copy
  // lives inside the translucent .pdp__info card — so the water behind the
  // page can safely read at full banner-page strength without hurting
  // legibility. Doing so keeps one consistent tone across homepage /
  // collection / product, which is the whole point.
  var isProductPage = document.body.classList.contains("template-product");
  // Other bannerless pages (cart, generic pages) have copy sitting directly
  // on the page with no protecting card, so they stay capped much dimmer.
  var maxOpacity = heroEl || isProductPage ? 0.85 : 0.28;
  var target = 0;
  var current = 0;
  var raf = null;

  // Fixed, short ramp — not tied to banner height. A tall homepage hero
  // still occludes the video visually until you scroll past it, so
  // starting the ramp early costs nothing there; on shorter collection
  // banners it means the water is already visible shortly after the
  // first scroll, right behind the collection copy, instead of needing
  // several scrolls before it appears.
  var FADE_START = 40;
  var FADE_DISTANCE = 320;

  function onScroll() {
    var progress = (window.scrollY - FADE_START) / FADE_DISTANCE;
    target = Math.min(Math.max(progress, 0), 1) * maxOpacity;
  }

  function tick() {
    current += (target - current) * 0.08;
    video.style.opacity = String(current);
    if (Math.abs(target - current) > 0.002) {
      raf = requestAnimationFrame(tick);
    } else {
      raf = null;
    }
  }

  window.addEventListener(
    "scroll",
    function () {
      onScroll();
      if (!raf) raf = requestAnimationFrame(tick);
    },
    { passive: true }
  );

  onScroll();
  tick();
})();
